module.exports = __webpack_public_path__ + "4779caf128065b0eee40b2bd44f8a6c5.svg";